module.exports = __webpack_public_path__ + "static/media/solution_banner_4_js.bb99ace9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/solution_banner_4_js.png
// module id = 583
// module chunks = 0